// Keep the static recovery message until the app and its dependencies can load.
// A failed static import would otherwise leave an empty root with no way forward.
import("./main.tsx").catch((error: unknown) => {
  const heading = document.querySelector(".startup-message h1");
  const detail = document.getElementById("startup-detail");
  if (heading) heading.textContent = "Your learning space couldn’t load.";
  if (detail)
    detail.textContent =
      "Please reload to try again. Your saved learning has not been changed.";
  console.error("EduHanu could not start:", error);
});
